import {AxiosResponse} from 'axios';
import BaseApi from './BaseApi';
import {Headers} from '../index';
import LlmInteractionCategoryDTO = API_ATRIA.Schemas.LlmInteractionCategoryDTO;
import Any = jasmine.Any;

export default class AtriaApi extends BaseApi {
    constructor(baseUrl: string, token: string, headers: Headers) {
        super(`${baseUrl}/api`, token, headers);
    }

    getLlmInteractionCategories = (botUUID: string): Promise<AxiosResponse<LlmInteractionCategoryDTO[]>> =>
        this.secureAxiosClient.get<LlmInteractionCategoryDTO[]>(
            `/llm/interaction/categories/bot/${botUUID}`
        );

    createOrUpdateLlmInteractionCategoryForBot = (
        botUUID: string,
        interactionCategory: LlmInteractionCategoryDTO
    ): Promise<AxiosResponse<LlmInteractionCategoryDTO>> => {
        if (interactionCategory.id) {
            return this.updateLlmInteractionCategoryForBot(botUUID, interactionCategory);
        } else {
            return this.createLlmInteractionCategoryForBot(botUUID, interactionCategory);
        }
    };

    createLlmInteractionCategoryForBot = (
        botUUID: string,
        interactionCategory: LlmInteractionCategoryDTO
    ): Promise<AxiosResponse<LlmInteractionCategoryDTO>> => {
        return this.secureAxiosClient.post<any>(`/llm/interaction/categories/bot/${botUUID}`, interactionCategory);
    };

    updateLlmInteractionCategoryForBot = (
        botUUID: string,
        interactionCategory: LlmInteractionCategoryDTO
    ): Promise<AxiosResponse<LlmInteractionCategoryDTO>> => {
        return this.secureAxiosClient.put<any>(`/llm/interaction/categories/bot/${botUUID}/${interactionCategory.id}`, interactionCategory);
    };

    createLlmInteractionCategoriesForBot = (
        botUUID: string,
        interactionCategories: LlmInteractionCategoryDTO[]
    ): Promise<AxiosResponse<LlmInteractionCategoryDTO[]>> => {
        return this.secureAxiosClient.post<any>(`/llm/interaction/categories/bot/${botUUID}/multiple`, interactionCategories);
    };

    deleteLlmInteractionCategory = (botUUID: string, interactionCategoryId: number): Promise<Any> =>
        this.secureAxiosClient.delete(
            `/llm/interaction/categories/bot/${botUUID}/${interactionCategoryId}`
        );

    deleteLlmInteractionCategories = (botUUID: string, interactionCategoryIds: number[]): Promise<Any> =>
        this.secureAxiosClient.delete(
            `/llm/interaction/categories/bot/${botUUID}/multiple`, {data: interactionCategoryIds}
        );

    isCategorisationEnabled = (botUUID: string): Promise<AxiosResponse<boolean>> =>
        this.secureAxiosClient.get<boolean>(
            `/llm/interaction/categories/bot/${botUUID}/enable`
        );

    enableOrDisableCategorisation = (botUUID: string, enable: boolean): Promise<Any> =>
        this.secureAxiosClient.post(
            `/llm/interaction/categories/bot/${botUUID}/enable`, enable
        );

}
